/**
* Stacked Hero Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Stacked Hero Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'stacked-hero-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      // const titleContainer = $( '.stacked-hero-banner__container' ).height();
      // const heroCurvedContent = $( '.stacked-hero-banner__content' ).height();
      // const newHeight = heroCurvedContent - titleContainer;
      // $( '.stacked-hero-banner__content' ).height( newHeight );


      // if ( window.innerWidth >= 769 ) {
      //   $( '.stacked-hero-banner__content' ).height( newHeight );
      // } else if ( window.innerWidth <= 768 ) {
      //   $( '.stacked-hero-banner__content' ).height( newHeight );
      // }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'stacked-hero-banner', COMPONENT );
} )( app );
